/** @format */
import { Empty } from "antd";
import Icon from "../../Assets/Icons";
import {
  RenderDate,
  RenderDetails,
  RenderName,
  RenderService,
  RenderStatus,
} from "../global/table-components";
import {
  deleteAirports,
  getAllAirports,
  setAirportID,
  setDelete,
  setEdit,
  setServicesAirports,
} from "../../store/airports";

import { Link } from "react-router-dom";
import FilterPop from "../Shared/TableFilter";
import { useState } from "react";
import { ClickAwayListener } from "@mui/material";
import ActionModal from "../pops/global modals/action-modal";
import { useDispatch } from "react-redux";
import {
  baneClient,
  deleteClient,
  getAllClients,
} from "../../services/clintServices";
import { deleteCategoryRTK } from "../../store/category";
import { baneClientAction, setClientID } from "../../store/clients";
// import "./_index.scss";
import { grid, statusValues } from "../../constant/table";
import { getAll, getOne, getOneDetails } from "../../store/helper";
import { banDriver, getAllDrivers } from "../../store/drivers";
import { setExpensetID } from "../../store/expenses";
import { getAllBannars } from "../../store/banners";

export default function Table({
  header,
  data,
  link,
  searchValues,
  getSearchValue,
  name,
  hideAction,
  setOpenEdit,
  action,
  setSelectedRow,
  details1,
  details2,
}) {
  const [isOpen, setIsOpen] = useState({});
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [values, setValues] = useState({});
  let dispatch = useDispatch();
  const toggleModal = (stateName, value) => {
    setIsOpen({ ...isOpen, [stateName]: value ?? !isOpen[stateName] });
  };
  //handle block
  const handleBaneClick = (item) => {
    dispatch(setClientID(item.id));
    setValues(item);
    setShowBlockModal(true);
  };
  //handle block
  const handleDeleteClick = (item) => {
    dispatch(setClientID(item.id));
    setValues(item);
    setShowBlockModal(true);
  };

  const handleBaneClient = () => {
    dispatch(baneClient("/client-banned/" + values.id)).then((res) => {
      // dispatch(baneClientAction(values));
      dispatch(getAllClients("/clients"));
      setShowBlockModal(false);
    });
  };
  const handleBaneDrivers = () => {
    dispatch(banDriver({ id: values.id, params: { status: "inactive" } })).then(
      (res) => {
        dispatch(getAllDrivers("/drivers"));
        setShowBlockModal(false);
      }
    );
  };
  const handleDeleteClient = () => {
    dispatch(deleteClient(`/${name}/` + values.id)).then((res) => {
      dispatch(getAllClients(`/${name}`));
      dispatch(getAllAirports(`/airports`));
      dispatch(getAllBannars(`/banners`));

      setShowBlockModal(false);
    });
  };
  const handelEdit = (values) => {
    setOpenEdit(true);
    dispatch(getOne({ path: `/${name}/`, id: values.id }));
    dispatch(setAirportID({ id: values.id }));
    if (setSelectedRow) setSelectedRow(values);
  };
  const handelViewExpense = (_id) => {
    setOpenEdit(true);
    dispatch(getOne({ path: "/driversMonies/", id: _id }));
    dispatch(setExpensetID({ id: _id }));
  };

  const renderData = (key, values) => {
    switch (key) {
      case "target":
        return (
          <a href={values[key]} target="_blank" className="link text--primary">
            لينك العرض
          </a>
        );

      case "created_at":
        return <RenderDate data={values[key]} />;

      case "balance":
        return (
          <span>
            <b>{values[key]} د.ك</b>
          </span>
        );

      case "name":
        return <RenderName data={values} />;
      case "details":
        return <RenderDetails data={values[details1][details2]} />;
      case "serviceData":
        return <RenderService data={values?.service?.name_ar} />;

      case "status":
        return <RenderStatus data={statusValues[values[key]]} />;

      case "setting":
        return (
          <div className="table-cont__row__settings">
            {name === "airports" || name === "banners" ? (
              <>
                <Icon name="edit" onClick={() => handelEdit(values)} />
                <Icon name="delete" onClick={() => handleDeleteClick(values)} />
              </>
            ) : name === "expenses" ? (
              <>
                <Icon name="eye" onClick={() => handelViewExpense(values.id)} />
              </>
            ) : name === "clients" ? (
              <>
                <Link to={link + values.id}>
                  <Icon name="eye" />
                </Link>
                {!hideAction && (
                  <Icon
                    name={values.status === "active" ? "block" : "delete"}
                    onClick={() => handleBaneClick(values)}
                  />
                )}
              </>
            ) : name === "drivers" || name === "driversLastOrders" ? (
              <>
                <Link to={link + values.id}>
                  <Icon
                    name="eye"
                    onClick={() => {
                      dispatch(getOne({ path: "/driver/", id: values.id }));
                    }}
                  />
                </Link>
                {values.status === "active" && (
                  <Icon name="block" onClick={() => handleBaneClick(values)} />
                )}
              </>
            ) : (
              <Link to={link + values.id}>
                <Icon name="eye" />
              </Link>
            )}
          </div>
        );
        break;
      case "total":
        return (
          <span>
            <b>{values[key]} د.ك</b>
          </span>
        );

      case "orders_amounts":
        return (
          <span>
            <b>{values[key]} د.ك</b>
          </span>
        );
      case "banner_type":
        return (
          <div>
            <b>{values[key].name}</b>
          </div>
        );
      default:
        return <span>{values[key] ?? "-"}</span>;
    }
  };
  return (
    <div className="table-cont">
      <ActionModal
        data={values}
        type={
          name === "airports"
            ? "delete"
            : name === "clients"
            ? values.status === "active"
              ? "block"
              : "delete"
            : "delete"
        }
        showModal={showBlockModal}
        setShowModal={setShowBlockModal}
        action={
          action ?? name === "airports"
            ? handleDeleteClient
            : name === "drivers"
            ? handleBaneDrivers
            : name === "clients"
            ? values.status === "active"
              ? handleBaneClient
              : handleDeleteClient
            : handleDeleteClient
        }
        msg={
          name === "drivers"
            ? "حظر السائق"
            : name === "banners"
            ? "حذف الاعلان"
            : name === "airports"
            ? "حذف المطار"
            : ""
        }
        // msg={name="drivers" ? "حظر السائق" : ""}
      />

      <div
        className="table-cont__header"
        style={{ gridTemplateColumns: grid[name] }}
      >
        {header?.map((item) => {
          return (
            <div className="table-cont__header__item" key={item?.headerName}>
              <span>{item?.headerName}</span>{" "}
              {item.searchable && (
                <ClickAwayListener
                  onClickAway={() => toggleModal(item?.key, false)}
                >
                  <div>
                    <Icon
                      name="downArrow"
                      onClick={() => toggleModal(item?.key)}
                    />{" "}
                    <FilterPop
                      options={item?.options}
                      showModal={isOpen[item?.key]}
                      stateName={item?.key}
                      searchValues={searchValues[item?.key]}
                      getSearchValue={getSearchValue}
                      label={item?.headerName}
                      hideModal={() => toggleModal(item?.key, false)}
                    />
                  </div>
                </ClickAwayListener>
              )}
            </div>
          );
        })}
      </div>
      <>
        {data?.length === 0 ? (
          <div>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<span>لا يتوافر بيانات</span>}
            />
          </div>
        ) : (
          <>
            {data?.map((row) => (
              <div
                className="table-cont__row"
                key={row.id}
                style={{ gridTemplateColumns: grid[name] }}
              >
                {header?.map((item) => {
                  return renderData(item.key, row);
                })}
              </div>
            ))}
          </>
        )}
      </>
    </div>
  );
}
